import { useCallback, useContext } from "react";
import { OverlayTriggerStateContext } from "react-aria-components";

import { Cross } from "components/icons/generated";

import Box from "../Box";
import ButtonIcon from "../ButtonIcon";
import TypographyHeading from "../Typography/Heading";
import styles from "./styles.module.css";
import { useIsDismissable } from "./useIsDismissable";

type ModalHeaderProps = {
  title: string;
  onClose?: () => void;
};

const ModalHeader = ({ title, onClose }: ModalHeaderProps) => {
  const state = useContext(OverlayTriggerStateContext);
  const isDismissable = useIsDismissable();

  const handleClose = useCallback(() => {
    onClose?.();
    state?.close();
  }, [onClose, state]);

  return (
    <Box className={styles.header} align="center" justify="between" fullWidth>
      <TypographyHeading className={styles.headerTitle} variant="p-t5" slot="title">
        {title}
      </TypographyHeading>
      <ButtonIcon
        icon={Cross}
        onPress={handleClose}
        disabled={!isDismissable}
        className={styles.closeButton}
        variant="ghost"
      >
        Close
      </ButtonIcon>
    </Box>
  );
};

ModalHeader.displayName = "DS.Modal.Header";

export default ModalHeader;
